module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA0NCA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQzLjEgMzNMMTAuNiA2NS41TDAuODk5OTk0IDU1LjhMMjUuMyAzM0wwLjg5OTk5NCAxMC4zTDEwLjYgMC41TDQzLjEgMzNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/components/Galerija/FullScreen/chevron-right.svg
// module id = 1004
// module chunks = 132729432747416